import React, { useState, useEffect } from "react";
import { Box, Typography, Card, useTheme, Container } from "@mui/material";
import { Helmet } from "react-helmet-async";
import PositionsTable from "./PositionsTable";
import { getPositions } from "../../utils/helpers";
import { usePositionsState } from "../../hooks/useOptimizedState";
import {
  excludeSmaFromAccountingFunds,
  excludeSmaFromFunds,
  excludeSmaFromLots,
} from "./positionsUtils";

const Positions = () => {
  const theme = useTheme();
  const { funds, lots, strategies, custodians, accountingData, managers } = usePositionsState();

  const [positions, setPositions] = useState([]);
  const [filteredPositions, setFilteredPositions] = useState([]);

  const accountingFunds = accountingData[0]?.funds;
  const filteredFunds = excludeSmaFromFunds(funds, managers);
  const filteredLots = excludeSmaFromLots(lots, managers);
  const filteredAccountingFunds = excludeSmaFromAccountingFunds(accountingFunds, managers);

  useEffect(() => {
    if (funds && lots && strategies && custodians) {
      const positionsData = getPositions(
        filteredFunds,
        strategies,
        filteredLots,
        custodians
      );
      setPositions(positionsData);
      setFilteredPositions(positionsData);
    }
  }, [funds, lots, strategies, custodians, managers]);

  return (
    <>
      <Helmet>
        <title>Positions | Vantage Alpha</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: theme.palette.grey[50],
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                mb: 1,
              }}
            >
              Positions
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
              }}
            >
              View and manage portfolio positions across funds and strategies
            </Typography>
          </Box>

          <Card
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              border: `1px solid ${theme.palette.divider}`,
            }}
          >
            <PositionsTable
              positions={filteredPositions}
              originalPositions={positions}
              funds={filteredFunds}
              strategies={strategies}
              custodians={custodians}
              accountingFunds={filteredAccountingFunds}
            />
          </Card>
        </Container>
      </Box>
    </>
  );
};

export default Positions;
